define('models/accounts/accountsummary_collection',[
	'backbone',
	'models/accounts/accountsummary'
], function(Backbone, AccountSummary){
    var AccountSummaryList = Backbone.Collection.extend({
        initialize: function(options){
            options = options || {};           
        },
        model: AccountSummary
    });
    return AccountSummaryList;
});

